import qs from 'qs';
import { baseConfig } from '../../../config/algolia';
import { ContentfulMetafieldCollection } from '@jbhi-fi/apis/src/contentful/types';
const indexName = baseConfig.product_families_index ?? '';

export type SearchState = {
  query?: string;
  page?: string;
  refinementList?: any;
  range?: any;
  Price?: any;
  hitsPerPage?: string | number;
  sortBy?: string;
  toggle?: any;
};

export const createRoutingURL = (state: SearchState, isResultsPage: boolean = false) => {
  const newUrl: any = {};

  if (isResultsPage) {
    // Query
    newUrl.query = state.query;
  }
  // Page
  if (!!state.page as boolean) {
    newUrl.page = state.page;
  }

  // Hits Per Page
  if (!!state.hitsPerPage as boolean) {
    newUrl.hitsPerPage = state.hitsPerPage;
  }

  // Sort By
  if (!!state.sortBy && state.sortBy !== indexName) {
    newUrl.sortBy = state.sortBy.replace(`${indexName}_`, '');
  }

  // Price Range
  if (!!state.range && state.range['facets.Price']) {
    newUrl.Price = {};
    const splitPrice = state.range['facets.Price'].split(':');
    splitPrice[0] && (newUrl.Price.min = splitPrice[0]);
    splitPrice[1] && (newUrl.Price.max = splitPrice[1]);
  }

  // Refinements
  if (!!state.refinementList as boolean) {
    Object.keys(state.refinementList).forEach(key => {
      if (state.refinementList[key] !== '') {
        newUrl[key.replace('facets.', '')] = state.refinementList[key];
      }
    });
  }

  // Sale Items
  if (!!state.toggle && state.toggle.onPromotion) {
    newUrl.saleItems = state.toggle.onPromotion;
  }

  return Object.keys(newUrl).length ? `?${qs.stringify(newUrl, { indices: false })}` : ``;
};

export const searchStateToUrl = (
  location: typeof window.location,
  searchState: SearchState,
  isResultsPage: boolean = false
) => (searchState ? `${location.pathname}${createRoutingURL(searchState, isResultsPage)}` : '');

export const urlToSearchState = (
  { search }: typeof window.location,
  collection?: ContentfulMetafieldCollection | null,
  isResultsPage?: boolean
) => {
  const urlQs: any = qs.parse(search.slice(1));
  const newUrl: any = {};
  const queryKeys = ['page', 'hitsPerPage', 'sortBy', 'Price', 'saleItems'];
  if (isResultsPage) {
    queryKeys.push('query');
    // Query
    newUrl.query = urlQs.query;
  }

  // Page
  newUrl.page = urlQs.page || 1;

  // Refinements
  newUrl.refinementList = Object.keys(urlQs)
    .filter(key => !queryKeys.includes(key))
    .reduce((obj: any, key) => {
      obj[`facets.${key}`] = Array.isArray(urlQs[key]) ? urlQs[key] : [urlQs[key]];
      return obj;
    }, {});

  // Range
  newUrl.range = Object.keys(urlQs)
    .filter(key => ['Price'].includes(key))
    .reduce((obj: any, key) => {
      const min = urlQs[key]?.min || '';
      const max = urlQs[key]?.max || '';
      obj[`facets.${key}`] = `${min}:${max}`;
      return obj;
    }, {});

  // Hits Per Page
  newUrl.hitsPerPage = urlQs.hitsPerPage || 36;

  // Sort By
  newUrl.sortBy = !!urlQs.sortBy
    ? `${indexName}_${urlQs.sortBy}`
    : collection && collection.sortMethod && !isResultsPage
    ? indexName + collection.sortMethod
    : indexName;

  // Toggle
  const toggle = urlQs.saleItems ? { onPromotion: urlQs.saleItems === 'true' } : undefined;
  if (toggle) newUrl.toggle = toggle;

  return qs.parse(newUrl);
};
